import videojs from 'video.js'

const Button = videojs.getComponent('Button')

class BackButton extends Button {
  constructor(player, options) {
    super(player, options)

    this.controlText(this.localize('Seek back 15 seconds'))
  }

  buildCSSClass() {
    return `vjs-fontawesome vjs-back-button d-none d-md-block ${super.buildCSSClass()}`
  }

  handleClick() {
    this.player().currentTime(this.player().currentTime() - 15)
  }
}

export default BackButton
